import extractApiData from 'Helpers/extractApiData'
import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams, serializeWithArray } from 'Helpers/encodeParams'

const endpoints = (baseURL => {
  return {
    getAbTestIdByInvio: idSending =>
      `${baseURL}/sending/${encodeURIComponent(idSending)}/AbTestId`,
    getABTestConfigById: idABTest =>
      `${baseURL}/abtest/${encodeURIComponent(idABTest)}/config`,
    getABTestList: (idList, params) =>
      `${baseURL}/list/${encodeURIComponent(
        idList
      )}/abtest?${serializeWithArray(params)}`,
    getAggregateReport: idAbTest =>
      `${baseURL}/abtest/${encodeURIComponent(idAbTest)}/AggregateReportId`,
    getRecoverable: idAbTest =>
      `${baseURL}/abtest/${encodeURIComponent(idAbTest)}/Recoverable`,
    updateRecover: idAbTest =>
      `${baseURL}/abtest/${encodeURIComponent(idAbTest)}/Recover`,
    deleteAbTest: idAbTest =>
      `${baseURL}/abtest/${encodeURIComponent(idAbTest)}`,
    saveABTestConfig: () => `${baseURL}/abtest/config`,
    updateABTestConfig: () => `${baseURL}/abtest/config/update`,
    startProcessAbTest: idAbTest =>
      `${baseURL}/abtest/${idAbTest}/StartProcess`,
    getAbTestGlobalStatus: idAbTest =>
      `${baseURL}/abtest/${encodeURIComponent(idAbTest)}`,
    getAsycQueueConfId: idAbTest =>
      `${baseURL}/abtest/${encodeURIComponent(idAbTest)}/AsycQueueConfId`,
    checkScheduleAbTestById: (idAbTest, internalTimezoneCode) =>
      `${baseURL}/abtest/${idAbTest}/CheckSchedule/Timezone/${internalTimezoneCode}`,
    scheduleAbTestById: (idAbTest, internalTimezoneCode) =>
      `${baseURL}/abtest/${idAbTest}/Schedule/Timezone/${internalTimezoneCode}`,
    updateABTestResults: idABTest =>
      `${baseURL}/abtest/${encodeURIComponent(idABTest)}/results`,
    getABTestResultById: idABTest =>
      `${baseURL}/abtest/${encodeURIComponent(idABTest)}/results`,
    isAbTestReschedulable: (idABTest) =>
      `${baseURL}/abtest/${encodeURIComponent(idABTest)}/Reschedulable`,
    rescheduleAbTest: (idABTest) =>
      `${baseURL}/abtest/${encodeURIComponent(idABTest)}/Reschedule`,
    getAggregateReportIDByABTestID: (idABTest) =>
      `${baseURL}/abtest/${encodeURIComponent(idABTest)}/AggregateReportId`,
    isAbTestResumable: (idABTest) =>
      `${baseURL}/abtest/${encodeURIComponent(idABTest)}/Resumable`,
    resumeAbTest: (idABTest) =>
      `${baseURL}/abtest/${encodeURIComponent(idABTest)}/Resume`,
    cleanABTest: (idABTest) =>
      `${baseURL}/abtest/${encodeURIComponent(idABTest)}/Clean`,
    stopABTest: (idABTest) =>
      `${baseURL}/abtest/${encodeURIComponent(idABTest)}/Stop`,
    scheduleAbTestWinner: (idABTest, scheduleDateCTZ) =>
      `${baseURL}/abtest/${encodeURIComponent(idABTest)}/ScheduleWinner/${scheduleDateCTZ}`,
    aBTestSetWinner: (idABTest, idMessage) =>
      `${baseURL}/abtest/${encodeURIComponent(idABTest)}/message/${idMessage}/winner`

  }
})(process.env.BEABTEST_URL)

export const beABTestABTestSetWinner = (idABTest, idMessage) => {
  return apiWrapper({
    method: 'put',
    url: endpoints.aBTestSetWinner(idABTest, idMessage)
  }).then(extractApiData)
}

export const beABTestScheduleAbTestWinner = (idABTest, scheduleDateCTZ) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.scheduleAbTestWinner(idABTest, scheduleDateCTZ)
  }).then(extractApiData)
}

export const beABTestStopABTest = idABTest => {
  return apiWrapper({
    method: 'put',
    url: endpoints.stopABTest(idABTest)
  }).then(extractApiData)
}

export const beABTestCleanABTest = idABTest => {
  return apiWrapper({
    method: 'put',
    url: endpoints.cleanABTest(idABTest)
  }).then(extractApiData)
}

export const beABTestResumeAbTest = idABTest => {
  return apiWrapper({
    method: 'put',
    url: endpoints.resumeAbTest(idABTest)
  }).then(extractApiData)
}

export const beABTestIsAbTestResumable = idABTest => {
  return apiWrapper({
    method: 'get',
    url: endpoints.isAbTestResumable(idABTest)
  }).then(extractApiData)
}

export const beABTestGetAggregateReportIDByABTestID = idABTest => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getAggregateReportIDByABTestID(idABTest)
  }).then(extractApiData)
}

export const beABTestRescheduleAbTest = idABTest => {
  return apiWrapper({
    method: 'put',
    url: endpoints.rescheduleAbTest(idABTest)
  }).then(extractApiData)
}

export const beABTestGetABTestResultById = idABTest => {
  return apiWrapper({
    method: 'put',
    url: endpoints.getABTestResultById(idABTest)
  }).then(extractApiData)
}

export const beABTestIsAbTestReschedulable = idABTest => {
  return apiWrapper({
    method: 'get',
    url: endpoints.isAbTestReschedulable(idABTest)
  }).then(extractApiData)
}

export const beABTestUpdateABTestResults = idABTest => {
  return apiWrapper({
    method: 'get',
    url: endpoints.updateABTestResults(idABTest)
  }).then(extractApiData)
}

export const beABTestGetAbTestIdByInvio = idSending => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getAbTestIdByInvio(idSending)
  }).then(extractApiData)
}

export const beABTestGetABTestConfigById = idABTest => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getABTestConfigById(idABTest)
  }).then(extractApiData)
}

export const beABTestGetAbTestList = (idList, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getABTestList(idList, params)
  }).then(extractApiData)
}

export const beABTestGetAggregateReport = idAbTest => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getAggregateReport(idAbTest)
  }).then(extractApiData)
}

export const beABTestGetRecoverable = idAbTest => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getRecoverable(idAbTest)
  }).then(extractApiData)
}

export const beABTestUpdateRecover = idAbTest => {
  return apiWrapper({
    method: 'put',
    url: endpoints.updateRecover(idAbTest)
  }).then(extractApiData)
}

export const beABTestDeleteAbTest = idAbTest => {
  return apiWrapper({
    method: 'delete',
    url: endpoints.deleteAbTest(idAbTest)
  }).then(extractApiData)
}

export const beABTestSaveABTestConfig = data => {
  const jsondata = JSON.stringify(data)
  const url = endpoints.saveABTestConfig()
  return apiWrapper({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: jsondata
  }).then(extractApiData)
}

export const beABTestUpdateABTestConfig = data => {
  return apiWrapper({
    method: 'post',
    url: endpoints.updateABTestConfig(),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beABTestStartProcessAbTest = (idABTest, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.startProcessAbTest(idABTest),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beABTestGetGlobalStatus = idAbTest => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getAbTestGlobalStatus(idAbTest)
  }).then(extractApiData)
}

export const beABTestGetAsycQueueConfId = idAbTest => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getAsycQueueConfId(idAbTest)
  }).then(extractApiData)
}

export const beABTestCheckScheduleAbTestById = (idAbTest, internalTimezoneCode, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.checkScheduleAbTestById(idAbTest, internalTimezoneCode),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const beABTestScheduleAbTestById = (idAbTest, internalTimezoneCode, data) => {
  return apiWrapper({
    method: 'post',
    url: endpoints.scheduleAbTestById(idAbTest, internalTimezoneCode),
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(data)
  }).then(extractApiData)
}

export const ABTEST_STATUS_UNRECOVERABLE = -2
export const ABTEST_STATUS_ERROR = -1
export const ABTEST_STATUS_CONFIGURATION = 0
export const ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_STARTED = 1
export const ABTEST_STATUS_SENDING_OF_WINNER_MESSAGE_STARTED = 2
export const ABTEST_STATUS_PRE_ENQUEUING = 3
export const ABTEST_STATUS_ENQUEUING = 4
export const ABTEST_STATUS_POST_ENQUEUING = 5
export const ABTEST_STATUS_SCHEDULING = 6
export const ABTEST_STATUS_WAITING_FOR_SENDING_OF_TEST_MESSAGES = 7
export const ABTEST_STATUS_WINNER_MESSAGE_DEFINED = 11
export const ABTEST_STATUS_SENDING_OF_TEST_MESSAGES_COMPLETED = 12 // TERMINATO PER 100%
export const ABTEST_STATUS_WINNER_MESSAGE_SCHEDULED = 13 // WINNER SCHEDULED
export const ABTEST_STATUS_COMPLETED = 14 // TERMINATO AUTO & MANUALE
export const ABTEST_STATUS_STOP_DURING_TEST = 15 // STOP INVIO TEST
export const ABTEST_STATUS_STOP_DURING_WINNER = 16 // STOP INVIO WINNER
export const ABTEST_STATUS_SCHEDULED = 0
export const ABTEST_STATUS_SUGGESTED_TEST_DATE = 1
export const ABTEST_STATUS_SUGGESTED_WINNER_DATE = 2
export const ABTEST_STATUS_SUGGEST_BOTH_DATE = 3

export const ABTEST_SCHEDULEDSTATUS_ERROR = -1
export const ABTEST_SCHEDULEDSTATUS_SCHEDULED = 0
export const ABTEST_SCHEDULEDSTATUS_SUGGESTEDTESTDATE = 1
export const ABTEST_SCHEDULEDSTATUS_SUGGESTEDWINNERDATE = 2
export const ABTEST_SCHEDULEDSTATUS_SUGGESTBOTHDATE = 3
